<div class="voucher-history">
  <!-- ⚠ track $index: mehrere Buchungen koennen dieselbe Sekunde tragen. -->
  @for (entry of history$ | async; track $index) {
    <div class="voucher-history__entry">
      <div class="voucher-history__label">
        <p class="voucher-history__type">
          {{ "PAGES.VOUCHER.HISTORY.TYPE." + entry.history_type | translate }}
        </p>
        <p class="voucher-history__time">
          <span class="voucher-history__clock"
            >{{ entry.history_time | date: "dd.MM.yyyy, HH:mm" }} Uhr</span
          >&ngsp;<span class="voucher-history__ago"
            >({{ entry.history_time | relativeTime }})</span
          >
        </p>
      </div>

      <span class="voucher-history__value"
        >€ {{ entry.history_delta_value | number: "1.2-2" }}</span
      >
    </div>
  } @empty {
    <p class="voucher-history__empty">
      {{ "PAGES.VOUCHER.HISTORY.EMPTY" | translate }}
    </p>
  }
</div>
